module.exports = __webpack_public_path__ + "img/pencil.8d49db79.svg";